var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 223,
    viewBox: "0 0 224 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.922 123.923C158.749 141.49 133.368 153.706 105.013 150.237C79.4187 147.105 61.9599 129.974 76.7759 104.568C83.7893 92.5421 100.13 82.7997 114.077 87.5712C129.616 92.8871 119.438 112.028 110.346 118.261C89.1096 132.82 57.2289 130.891 39.7274 109.42C19.0015 83.9933 19.0107 65.1124 19.0517 65.3335",
    stroke: "#22428F",
    strokeWidth: 6.79294,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.703 154.134C176.63 151.343 176.845 148.4 176.908 145.454C177.114 135.783 180.451 125.381 187.461 118.241C177.849 123.27 163.716 126.613 154.07 120.858",
    stroke: "#22428F",
    strokeWidth: 6.79294,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.ced78b9792760226620f3bee47ec34b0.svg";
export { ForwardRef as ReactComponent };